import React from 'react';
import { useTranslation } from 'react-i18next';
import './VetoFlow.css';

/**
 * Step-by-step timeline showing each veto round with team names and results.
 */
export default function VetoTimeline({ rounds, currentRound, vetoState }) {
  const { t } = useTranslation();
  const teamName = (team) => {
    if (!vetoState) return team === 'team1' ? 'T1' : 'T2';
    return team === 'team1'
      ? (vetoState.team1_name || 'T1')
      : (vetoState.team2_name || 'T2');
  };

  const teamPlayerNames = (team) => {
    if (!vetoState?.player_names) return '';
    const ids = vetoState[`${team}_players`] || [];
    const names = ids.map(id => vetoState.player_names[id]).filter(Boolean);
    return names.join(', ');
  };
  return (
    <div className="veto-timeline">
      {rounds.map((rnd, i) => {
        const isActive = i === currentRound;
        const isDone = rnd.status === 'complete';
        const teamClass = rnd.team;

        let icon = '';
        if (rnd.type === 'ban') icon = '\u2715';
        else if (rnd.type === 'pick') icon = '\u2713';
        else if (rnd.type === 'side') icon = '\u2694';

        let resultText = '';
        if (isDone && rnd.result) {
          if (rnd.type === 'ban' && rnd.result.banned_maps) {
            resultText = rnd.result.banned_maps.join(', ');
          } else if (rnd.type === 'pick' && rnd.result.picked_maps) {
            resultText = rnd.result.picked_maps.join(', ');
          } else if (rnd.type === 'side' && rnd.result.side) {
            resultText = rnd.result.side.toUpperCase();
          }
        }

        return (
          <div
            key={i}
            className={`timeline-step ${teamClass} ${isActive ? 'active' : ''} ${isDone ? 'done' : ''}`}
          >
            <div className="timeline-icon">{icon}</div>
            <div className="timeline-info">
              <span className="timeline-team" title={teamPlayerNames(rnd.team)}>
                {teamName(rnd.team)}
              </span>
              <span className={`timeline-type ${rnd.type === 'ban' ? 'ban-type' : rnd.type === 'pick' ? 'pick-type' : ''}`}>
                {rnd.type === 'ban' ? `Ban ${rnd.count}` : rnd.type === 'pick' ? 'Pick' : t('veto.timelineSide')}
              </span>
            </div>
            {resultText && <div className="timeline-result">{resultText}</div>}
          </div>
        );
      })}
    </div>
  );
}
